import {
  query,
  getDocs,
  Transaction,
  doc,
  DocumentSnapshot,
  getDocFromServer,
  deleteDoc,
} from 'firebase/firestore'
import firestore from '../../firestore'
import { CompanyCard } from '@leadgen/models/client'
import BaseService from '../BaseService'

class CompanyCardService extends BaseService {
  deleteCompanyCard = async ({
    companyId,
    companyCardId,
    transaction,
  }: {
    transaction?: Transaction
    companyId: string
    companyCardId: string
  }) => {
    const companyCardRef = doc(firestore.companyCards(companyId), companyCardId)
    if (transaction) {
      transaction.delete(companyCardRef)
    } else {
      await deleteDoc(companyCardRef)
    }
  }

  subscribeToCompanyCard = async ({
    companyId,
    companyCardId,
    onCompanyCardUpdated,
  }: {
    companyId: string
    companyCardId: string
    onCompanyCardUpdated: (company: CompanyCard) => void
  }) => {
    const { data, unsubscribe } = await this.onDoc({
      ref: doc(firestore.companyCards(companyId), companyCardId),
      onUpdated: onCompanyCardUpdated,
      forceServerResponse: true,
    })
    if (data == null) {
      throw new Error("CompanyCard doesn't exist")
    }
    return {
      data,
      unsubscribe,
    }
  }
  fetchCompanyCard = async ({
    companyId,
    companyCardId,
    transaction,
  }: {
    transaction?: Transaction
    companyId: string
    companyCardId: string
  }): Promise<CompanyCard> => {
    const companyCardRef = doc(firestore.companyCards(companyId), companyCardId)
    let companyCardDoc: DocumentSnapshot
    if (transaction) {
      companyCardDoc = await transaction.get(companyCardRef)
    } else {
      companyCardDoc = await getDocFromServer(companyCardRef)
    }
    if (!companyCardDoc.exists()) {
      throw new Error("CompanyCard doesn't exist")
    }
    return companyCardDoc.data() as CompanyCard
  }
  fetchCompanyCards = async ({ companyId }: { companyId: string }): Promise<CompanyCard[]> => {
    const companyCardsSnapshot = await getDocs(firestore.companyCards(companyId))
    return companyCardsSnapshot.docs.map(companyCardDoc => companyCardDoc.data())
  }
  subscribeToCompanyCards = async ({
    companyId,
    onCompanyCardAdded,
    onCompanyCardUpdated,
    onCompanyCardRemoved,
  }: {
    companyId: string
    onCompanyCardAdded: (companyCard: CompanyCard) => void
    onCompanyCardUpdated: (companyCard: CompanyCard) => void
    onCompanyCardRemoved: (companyCard: CompanyCard) => void
  }) => {
    const { data, unsubscribe } = await this.onSnapshot({
      query: query(firestore.companyCards(companyId)),
      onAdded: onCompanyCardAdded,
      onUpdated: onCompanyCardUpdated,
      onRemoved: onCompanyCardRemoved,
    })
    return {
      data,
      unsubscribe,
    }
  }
}

export default new CompanyCardService()
